import { ChangeDetectorRef, Component, DoCheck, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { SharedDataService } from '../../../../../@core/service/shared-data.service';
import { isEmpty, mongoId, stableSort } from '../../../../../@core/common/global';
import { BoxStatus, CaseDetails, EBoxStatus, SpoBoxModel } from '../../../../../@models/erp/spoBox';
import { IDocumentTree, TreeService } from '../../../../../@core/service/tree.service';
import { CompilationModel, EPackingStatus } from '../../../../../@models/erp/compilation';
import { AssociatedPfspo, LineItemModel } from '../../../../../@models/erp/lineItem';
import { ApiService } from '../../../../../@core/service/api.service';
import { NrkWindowComponent } from '../../../shared/nrk-window/nrk-window.component';
import { AvailabilityStatusData, CompilationTypeData, PackingStatusData, SpoStatusData, TransportStatusData } from '../../../../../@models/erp/compilationData';
import * as moment from 'moment';
import { ICheckboxChangeWithEvent } from '../../../shared/doc-form-checkbox/doc-form-checkbox.component';
import { EProductType } from '../../../../../@models/erp/finishedProduct';
import { LineItemContainerComponent } from '../line-item-container.component';

@Component({
  selector: 'ngx-box-selection',
  templateUrl: './box-selection.component.html',
  styleUrls: ['./box-selection.component.scss']
})
export class BoxSelectionComponent implements OnDestroy, OnChanges, OnInit {

  @Input() compilation: CompilationModel;
  @Input() disabled: boolean;
  @Input() spoBoxes: { [idx: number]: { [code: string] : SpoBoxModel[] } } = [] as any;
  @Input() idx: number;
  // @Input() spo: AssociatedPfspo | CompilationModel; // only used for code here TODO: use code directly
  @Input() docCode: string;
  @Input() spoIdx: number;
  @Input() item: LineItemModel;
  @Input() associatedCS: any;
  @Input() lineItemContainer: LineItemContainerComponent;
  @Output() setBoxBlockLines = new EventEmitter<any>();

  markAsExceptionEnabled = false;
  
  protected boxSort = {
    col: null,
    dir: 1
  };
  protected filterCurrentOC = false;
  protected boxBlockLines = [];

  protected lots: { selected: boolean, name: string }[] = [];
  
  protected originalPackingStatus = undefined;
  private subscriptions = [];

  statusText = PackingStatusData.text;
  BoxStatusType = EBoxStatus;
  typeData = CompilationTypeData;
  boxStatus = BoxStatus;
  packingStatus = EPackingStatus;
  isFromSpo = false;

  protected document: CompilationModel;


  
  constructor(protected data: SharedDataService, protected tree: TreeService, protected api: ApiService, protected cdRef: ChangeDetectorRef) { 
    // console.log('box-selection constructor');
  }

    // ngOnInit() {
  //   console.log('box-selection init');
  //   this.subscriptions.push(this.tree.documentTreeLoadedEvent.subscribe((tree: IDocumentTree) => this.onDocumentTreeLoaded()));
  // }
  ngOnInit() {
    if (this.spoIdx !== undefined) {
      this.docCode = this.item?.pfspo[this.spoIdx]?.code;
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  prevSpoBoxes = {};
  async ngOnChanges(changes: SimpleChanges) {

    if (changes.compilation?.currentValue) {
      this.document = this.compilation.type === CompilationTypeData.get('OC').id ? this.compilation : this.tree.linkedOC || this.compilation;
      this.originalPackingStatus = this.document.packingStatus;
    }


    // console.log('box-selection changes', changes, this.spoBoxes);
    this.boxSort.col = 'prodDate';
    this.boxSort.dir = 1;

    this.isFromSpo = ['SPO', 'PFSPO'].includes(CompilationTypeData.get(this.document.type).code);

    this.document.lineItems.forEach((li, idx) => {
      if (!li.finishedProduct?._id) li.finishedProduct = this.data.finishedProducts.find(f => mongoId(f) === mongoId(li.finishedProduct))
      // don't do optional chaining
      if (li.finishedProduct && li.finishedProduct.showMissingCpsWarning === undefined && li.finishedProduct.type === EProductType.Energy ) {
        li.finishedProduct.showMissingCpsWarning = true;
      }

      li.pfspo?.forEach(async (el) => this.associatedCS[el.code] = await this.api.findCombinedShipment(el.code));
      // console.log('===>onchanges', this.compilation.visibleFields);
      // li.tcChecked = this.compilation.visibleFields.includes('liTC' + li.position?.internalPos);

      // console.log('---&&&&', this.compilation.code);
      // if (changes.spoBoxes || changes.compilation) {
      //   if (['PFSPO', 'SPO'].includes(CompilationTypeData.get(this.compilation.type).code)) {
      //     this.getBoxBlockLines(idx, [this.compilation], [li]);
      //   } else {
      //     this.getBoxBlockLines(idx, li.pfspo.flatMap(spo => spo.doc), li.pfspo.flatMap(spo => spo.docLineItem));
      //   }
      // }

    })
    if (this.spoBoxes && !isEmpty(this.spoBoxes)) {
      const current = JSON.stringify(this.spoBoxes);
      if (current !== this.prevSpoBoxes) {
        // console.log('======================== spoboxes changed', changes);
        this.document.lineItems.forEach((li, idx) => {
          // console.log('&&&&&&&&&&&&&&&&&&&', idx, this.compilation.code, li.pfspo.flatMap(spo => spo.doc), li.pfspo.flatMap(spo => spo.docLineItem));
          if (['PFSPO', 'SPO'].includes(CompilationTypeData.get(this.document.type).code)) {
            this.getBoxBlockLines(idx, [this.document], [li]);
          } else {
            this.getBoxBlockLines(idx, li.pfspo.flatMap(spo => spo.doc), li.pfspo.flatMap(spo => spo.docLineItem));
          }
        })
        this.prevSpoBoxes = JSON.stringify(this.spoBoxes);
      }
    }
  }

  // prevSpoBoxes = {}
  // ngDoCheck(): void {
  //   // console.log('&&&&', this.compilation.code);
  //   if (isEmpty(this.spoBoxes, true) && isEmpty(this.prevSpoBoxes, true)) return;
  //   if (JSON.stringify(this.spoBoxes) !== this.prevSpoBoxes) {
  //     console.log('-------> spoboxes cahnge', JSON.stringify(this.spoBoxes), this.spoBoxes, this.prevSpoBoxes, isEmpty(this.spoBoxes, true), isEmpty(this.prevSpoBoxes, true) )
  //     this.compilation.lineItems.forEach((li, idx) => {
  //       // console.log('&&&&&&&&&&&&&&&&&&&', idx, this.compilation.code, li.pfspo.flatMap(spo => spo.doc), li.pfspo.flatMap(spo => spo.docLineItem));
  //       if (['PFSPO', 'SPO'].includes(CompilationTypeData.get(this.compilation.type).code)) {
  //         this.getBoxBlockLines(idx, [this.compilation], [li]);
  //       } else {
  //         this.getBoxBlockLines(idx, li.pfspo.flatMap(spo => spo.doc), li.pfspo.flatMap(spo => spo.docLineItem));
  //       }
  //     })
  //     this.prevSpoBoxes = JSON.stringify(this.spoBoxes);
  //   }
  // }

  getDirArrow(col: string) {
    if (this.boxSort.col === col) return this.boxSort.dir > 0 ? '▲' : '▼'
    return ''
  }

  getDisplayBoxes(boxes: SpoBoxModel[]) {

    // let ret = boxes.sort((a, b) => a.boxId > b.boxId ? 1 : -1);

    // // console.log('sorting boxes', this.boxSort, boxes);

    // if (this.boxSort.col === 'case') {
    //   return ret.sort((a, b) => a[this.boxSort.col] === b[this.boxSort.col] 
    //     ? 0 : +a[this.boxSort.col] < +b[this.boxSort.col] 
    //       ? this.boxSort.dir : - this.boxSort.dir);
    // } else if (this.boxSort.col) {
    //   return ret.sort((a, b) => a[this.boxSort.col] === b[this.boxSort.col] 
    //     ? 0 : a[this.boxSort.col] < b[this.boxSort.col] 
    //       ? this.boxSort.dir : - this.boxSort.dir);
    // }
    // return boxes

    if (this.filterCurrentOC) {
      boxes = boxes.filter(f => f.docRef === this.tree.linkedOC.code);
    }

    // console.log('boxes', boxes);

    // boxes = boxes.filter(box => {
    //   // console.log(box.boxId, box, this.data.getPos(box.spo, box.spoPos), this.spoIdx)
    //   return this.data.getPos(box.spo, box.spoPos) === this.spoIdx + 1
    //     // || this.data.getPos(box.spo, box.spoPos) === this.spoIdx
    // });
    // boxes = boxes.filter(box => this.data.getPos(box.spo, box.spoPos) === this.idx + 1)

    // console.log('boxes filtered', boxes);

    // console.time('getDisplayBoxes')
    const sorted =  stableSort(boxes, [(b) => b[this.boxSort.col], (b) => b.boxId], [this.boxSort.dir, 1], this.boxSort.col === 'case' ? [true, true] : []);
    // console.timeEnd('getDisplayBoxes')
    return sorted;
    // return stableSort(boxes, [(b) => b.docRef, (b) => b[this.boxSort.col], (b) => b.boxId], [1, this.boxSort.dir, 1]);
  }


  checkboxEnabled(box: SpoBoxModel, item: LineItemModel, checkDisabled = false, checkOpacity = false) {
    if (this.isFromSpo) return false;
    if (checkDisabled && !checkOpacity) {
      // console.log('checkboxEnabled', box.case, box.docRef, this.compilation.code, )
      return box.docRef && (box.docRef !== this.document.code || item.position.internalPos !== box.docRefPos) && (box.dnStatus === this.packingStatus.exception || box.status > EBoxStatus.assignedSpo) || null;
    } else if (checkOpacity) {
      return box.status !== EBoxStatus.free && (box.docRef !== this.document.code || item.position.internalPos !== box.docRefPos) || null;
    } else {
      if (box.docRef === this.document.code && item.position.internalPos === box.docRefPos || !box.docRef) {
        if (box.dnStatus !== EPackingStatus.exception) box.selected = box.status >= EBoxStatus.assignedSpo;
        return true; //box.status < EBoxStatus.assignedPallet; // && (item.position.internalPos === box.docRefPos || box.status === 0)
      }  
      return false;
    }
  }

  async refreshSelectStatus(win: NrkWindowComponent, idx: number, spo: string) {
    // this.loadBoxes();
    // const boxes = await this.api.loadSpoBoxes({ spo: spo });
    // console.log('refreshSelectStatus', this.spoBoxes, idx, spo, this.spoBoxes[idx], this.spoBoxes[idx][spo]);
    this.spoBoxes[idx][spo] = await this.api.loadSpoBoxes({ spo: spo })
    // console.log('refresh select status', this.spoBoxes[idx][spo]);
    this.spoBoxes[idx][spo].forEach(box => {
      box.selected = box.status > EBoxStatus.free;
    })
    this.spoBoxes[idx][spo]
      .sort((a: SpoBoxModel, b: SpoBoxModel) => 
        a.docRef === this.document.code
          ? -1 : 1)
      .sort((a: SpoBoxModel, b: SpoBoxModel) => 
        a.status === b.status 
          ? 0 : a.status > b.status 
            ? 1 : -1)

    win.toggle();
    // this.data.boxesAreLoading.pop();

    this.lots = [...new Set(this.spoBoxes[idx][spo].flatMap(m => m.lot))].map(m => ({ selected: false, name: m }));

    // console.log('===================>lots', this.lots);

    this.cdRef.detectChanges();
  }

  selectAllBoxes(boxes: SpoBoxModel[], selected, lineItem: LineItemModel) {
    boxes = boxes.filter(f => 
      f.dnStatus === EPackingStatus.exception
      || f.status === EBoxStatus.free
      || (f.status === EBoxStatus.assignedSpo && f.docRef === this.document.code && lineItem.position.internalPos === f.docRefPos)
    )
    boxes.forEach(box => {
      box.selected = selected
    });
    this.assignBoxes(boxes, lineItem);
  }

  markAs(status: EBoxStatus, lots: { selected: boolean, name: string }[] = undefined) {

    const hasLot = (box: SpoBoxModel, lots: { selected: boolean, name: string }[]) => {
      const selectedLots = lots.filter(f => f.selected).map(m => m.name);
      // return box.lot.length === 1 && selectedLots.includes(box.lot[0]);
      return box.lot.length > 0 && box.lot.every(lot => selectedLots.includes(lot));
    }

    this.getDisplayBoxes(this.spoBoxes[this.idx][this.docCode])
      ?.filter(box => (box.selected &&  (!lots || hasLot(box, lots))) && this.checkboxEnabled(box, this.item))
      ?.forEach(box => box.status = status)
  }

  setDnStatus(status: EPackingStatus) {
    this.getDisplayBoxes(this.spoBoxes[this.idx][this.docCode])
      ?.filter(box => box.selected && this.checkboxEnabled(box, this.item))
      ?.forEach(box => box.dnStatus = status)
  }

  // async onDocumentTreeLoaded() {
  //   console.log('on document tree loaded', this.tree);
  //   this.compilation.lineItems.forEach(async (li, idx) => {
  //     if (['PFSPO', 'SPO'].includes(CompilationTypeData.get(this.compilation.type).code)) {
  //       this.getBoxBlockLines(this.idx, [this.compilation],[li]);
  //     } else {
  //       this.getBoxBlockLines(this.idx, li.pfspo.flatMap(spo => spo.doc), li.pfspo.flatMap(spo => spo.docLineItem));
  //     }
  //   })
  // }

  async assignBoxes(boxes: SpoBoxModel[], lineItem: LineItemModel) {

    // spo.boxes = boxes.filter(f => f.selected);
    // spo.boxes.forEach(box => {
    //   box.status = free || !box.selected ? EBoxStatus.free : EBoxStatus.assignedSpo;
    //   box.docRef = free || !box.selected ? '' : this.compilation.code;
    //   box.dispatchDate = free || !box.selected ? null : this.compilation.vieDispatchDate;
    //   delete box.selected;
    // })
    // const oc = await this.api.loadCompilationByCode(this.tree.linkedOC.code);
    // // const li = oc.lineItems.find(f => f.position.internalPos === spo.pos);
    // const ref = li?.pfspo.find(f => f.code === spo.code);
    // console.log('linked OC', this.tree.linkedOC, oc, li, ref)
    // ref.boxes = spo?.boxes;
    // this.api.saveCompilation(oc);
    // this.event.emitReloadBoxes();
    // this.hidePopovers();

    // const selectedBoxes = boxes.filter(f => f.selected);
    // selectedBoxes.forEach(box => {
    //    box.status = free || !box.selected ? EBoxStatus.free : EBoxStatus.assignedSpo;
    //    box.docRef = free || !box.selected ? '' : this.compilation.code;
    //    box.dispatchDate = free || !box.selected ? null : this.compilation.vieDispatchDate;
    // })


    boxes.forEach(box => {
      if (box.dnStatus !== EPackingStatus.exception && (box.docRef === this.document.code && lineItem.position.internalPos === box.docRefPos) || !box.docRef) {
        box.status = !box.selected ? EBoxStatus.free : (box.status > EBoxStatus.free ? box.status : EBoxStatus.assignedSpo);
        box.docRef = !box.selected ? '' : this.document.code;
        box.docRefPos = !box.selected ? undefined : lineItem.position.internalPos;
        box.docRefProduct = !box.selected ? undefined : lineItem.finishedProduct.code;
        box.dispatchDate = !box.selected ? null : this.document.vieDispatchDate;
        // console.log('lineITempos',box.case, lineItem.position.internalPos === box.docRefPos || box.status === EBoxStatus.free, lineItem.position.internalPos, box.docRefPos, box.status);
      }
    })
  }

  async commitBoxes(boxes: SpoBoxModel[], lineItem: LineItemModel) {
    boxes.forEach(el => {
      // el.docRefPos = lineItem.position.internalPos;
      delete el.selected;
      if (el.status < EBoxStatus.assignedPallet) el.palletRef = null;
    });
    // console.log('=====> commit boxes', boxes)
    await this.api.saveSpoBoxes(boxes);
    this.lineItemContainer.loadBoxes();

    // console.log('commit boxes', this.originalPackingStatus, this.document.packingStatus);

    if (this.document.packingStatus !== this.originalPackingStatus) {
      //this.tree.synchronizeSharedFields(this.selected);
      await this.tree.synchronizeField(this.document, 'packingStatus');
      const doc = await this.api.loadCompilationByCode(this.document.code);
      const onStock = boxes.filter(f => f.status === EBoxStatus.damaged || EBoxStatus.retesting);
      // console.log('============>commit boxes', onStock)
      if (onStock.length) {
        const spo = await this.api.loadCompilationByCode(onStock[0].spo);
        spo.transportRun.availabilityStatus = AvailabilityStatusData.get('notCompleted').id;
        spo.transportRun.spoStatus = SpoStatusData.get('exception').id;
        // console.log('============>commit boxes spo', spo, )
        this.api.saveCompilation(spo);
      }
      this.compilation.packingStatus = doc.packingStatus;
      // console.log('this.tree.synchronizeField(this.document, packingStatus)', this.compilation.packingStatus, this)
    }
  }

  cancelEdit() {
    this.lineItemContainer.loadBoxes();
    this.markAsExceptionEnabled = false;
    this.document.packingStatus = this.originalPackingStatus;
  }

  getSumBoxesQuantity(boxes: SpoBoxModel[], lineItem: LineItemModel) {
    return {
      selectedBoxes: boxes?.filter(f => f.selected && (f.docRef === this.document.code && lineItem.position.internalPos === f.docRefPos)).length,
      selectedQuantity: boxes?.filter(f => f.selected && (f.docRef === this.document.code && lineItem.position.internalPos === f.docRefPos)).reduce((a, c) => a + (+c.quantity), 0),
      // assignedBoxes: boxes?.filter(f => f.selected || f.status >= EBoxStatus.assignedSpo).length,
      // assignedQuantity: boxes?.filter(f => f.selected || f.status >= EBoxStatus.assignedSpo).reduce((a, c) => a + (+c.quantity), 0),
      // freeBoxes: boxes?.filter(f => !f.selected && f.status < EBoxStatus.assignedSpo).length,
      // freeQuantity: boxes?.filter(f => !f.selected && f.status < EBoxStatus.assignedSpo).reduce((a, c) => a + (+c.quantity), 0),
    }
  }

  lastSelectedIndex: number;
  onBoxesCheckboxChange(boxes: SpoBoxModel[], idx:number, change: ICheckboxChangeWithEvent, lineItem: LineItemModel) {

    const event = change.event;
    const shiftKey = event.shiftKey;
    if (shiftKey && typeof this.lastSelectedIndex !== 'undefined') {
      const startIndex = Math.min(this.lastSelectedIndex, idx);
      const endIndex = Math.max(this.lastSelectedIndex, idx);
      for (let i = startIndex; i <= endIndex; i++) {
        boxes[i].selected = change.checked;
      }
    } else {
      boxes[idx].selected = change.checked;
    }
    this.lastSelectedIndex = idx;
    this.assignBoxes(boxes, lineItem);
  }

  private getBoxBlockLines(lineItemIdx: number, spo: CompilationModel[], spoLineItems: LineItemModel[]) {
    // console.log('+++++++++++++++++++++++++++++++++++++++++++', this.spoBoxes, lineItemIdx, spo);
    const tcData = {};
    spoLineItems.forEach((li,idx) => {
      // console.log('-->', this.compilation.code, CompilationTypeData.get(this.compilation.type).code)
      if (['PFSPO', 'SPO'].includes(CompilationTypeData.get(this.document.type).code)) {
        // if ((lineItem.tbCode || lineItem.expiryDate) && !tcData['doc']) {
        //   tcData['doc'] = {
        //     tbCode: lineItem.tbCode,
        //     fon: lineItem.factoryOrderNumber,
        //     expd: lineItem.expiryDate && moment(li.expiryDate),
        //   }
        // }
        li?.boxDetails?.forEach((details: CaseDetails) => {
          // console.log('-->tc', details.tc);
          if (!tcData[details.tc]) {
            tcData[details.tc] = {
              tbCode: li.tbCode,
              tc: details.tc,
              fon: li.factoryOrderNumber,
              date: details.tcDate && moment(details.tcDate),
              minProdDate: details.prodDate,
              maxProdDate: details.prodDate,
              expd: li.expiryDate && moment(li.expiryDate),
            }
          } else {
            tcData[details.tc].minProdDate = details.prodDate && moment.min(moment(tcData[details.tc].minProdDate), moment(details.prodDate));
            tcData[details.tc].maxProdDate = details.prodDate && moment.max(moment(tcData[details.tc].maxProdDate), moment(details.prodDate));
          }
        })
      } else {
        li?.boxDetails?.forEach((details: CaseDetails) => {
          const box = spo[idx]?.code && this.spoBoxes[lineItemIdx] && this.spoBoxes[lineItemIdx][spo[idx].code]?.find(f => f.case === details.case);
          // console.log('+++++++=box', spo[idx]?.code, box?.docRef, this.compilation.code, box?.docRefPos, this.compilation.lineItems[lineItemIdx]?.position );
          if (box && box.docRef === this.document.code && box.docRefPos === this.document.lineItems[lineItemIdx]?.position?.internalPos) {
            if (!tcData[details.tc]) {
              // console.log('box details date', details.tcDate);
              tcData[details.tc] = {
                tbCode: li.tbCode,
                tc: details.tc,
                fon: li.factoryOrderNumber,
                date: details.tcDate && moment(details.tcDate),
                minProdDate: details.prodDate,
                maxProdDate: details.prodDate,
                expd: li.expiryDate && moment(li.expiryDate),
              }
            } else {
              tcData[details.tc].minProdDate = details.prodDate && moment.min(moment(tcData[details.tc].minProdDate), moment(details.prodDate));
              tcData[details.tc].maxProdDate = details.prodDate && moment.max(moment(tcData[details.tc].maxProdDate), moment(details.prodDate));
            }
          }
        })
      }
    })

    // console.log('---------------------------------------------->', this.compilation.code, lineItemIdx, tcData, spoLineItems);

    this.boxBlockLines[lineItemIdx] = Object.keys(tcData).map(m => ({
      tbCode: tcData[m].tbCode,
      factoryOrderNumber: tcData[m].fon,
      numberOfTC: tcData[m].tc,
      dateOfTC: tcData[m].date?.format('YY-MM-DD'),
      minProdDate: tcData[m].minProdDate ? moment(tcData[m].minProdDate).format('YY-MM-DD') : '',
      maxProdDate: tcData[m].maxProdDate ? moment(tcData[m].maxProdDate).format('YY-MM-DD') : '',
      expiryDate: tcData[m].expd?.format('YY-MM-DD'),
    }));

    // console.log('-------------------------------------boxblocklines', tcData, this.boxBlockLines);
    // console.log('getBoxBlockLines emit', lineItemIdx, this.boxBlockLines[lineItemIdx])
    this.setBoxBlockLines.emit({ idx: lineItemIdx, lines: this.boxBlockLines[lineItemIdx] });

  }

  markAsException() {
    this.markAsExceptionEnabled = true;
    this.document.packingStatus = EPackingStatus.exception;
    this.disabled = false;
    // console.log('toggleMarkEnabled', this.disabled, this.markAsExceptionEnabled, this.document.packingStatus, this.originalPackingStatus)
    this.setDnStatus(EPackingStatus.exception);
  }

}
